// extracted by mini-css-extract-plugin
module.exports = {"divMainContain":"Layout_divMainContain__Pd69i","root1":"Layout_root1__31xDU","content":"Layout_content__sL6PT","hashLoader":"Layout_hashLoader__ld2FB"};